import { render, staticRenderFns } from "./AgendaDetail.vue?vue&type=template&id=ba59b40e"
import script from "./AgendaDetail.vue?vue&type=script&lang=js"
export * from "./AgendaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports